import { Suspense, lazy } from 'react';

import { createFileRoute } from '@tanstack/react-router';

const DashboardPage = lazy(() =>
  import('@/features/dashboards/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);

function DashboardPageWrapper() {
  return (
    <Suspense fallback={<div className="p-8 text-center text-quiet">Cargando dashboard...</div>}>
      <DashboardPage />
    </Suspense>
  );
}

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/dashboard')({
  component: DashboardPageWrapper,
});
